import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["disableHoverBackground", "variant", "children", "className", "enlargeOnHover", "size", "width", "height"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
// @ts-nocheck
//
// Hey, are you working in this file?
// Remove this block of code and help make our codebase a little bit stronger
//
// Do a little bit now to pay down the tech debt
import React from "react";
import { IconButton as MuiIconButton } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { RaiseColors } from "components/mui";
import classNames from "classnames";
import { jsx as _jsx } from "react/jsx-runtime";
var useStyles = makeStyles(function (theme) {
  return {
    circle: {
      border: "1px solid ".concat(RaiseColors.grayscale200),
      padding: 3,
      color: RaiseColors.glacier2400,
      height: 31,
      width: 31,
      "& .MuiIcon-root": {
        fontSize: 20
      }
    },
    borderlessCircle: {
      padding: 3,
      color: RaiseColors.glacier2400,
      height: 32,
      width: 32
    },
    miniSquare: {
      borderRadius: 0,
      padding: "2px",
      "& .MuiIcon-root": {
        fontSize: 16,
        marginRight: "4px"
      }
    },
    transition: {
      transition: "all 50ms cubic-bezier(.5,0,0,1)",
      "&:hover": {
        transform: "scale(1.15)"
      }
    },
    disableHoverBackground: {
      "&:hover": {
        background: "unset"
      }
    },
    animatedIcon: {
      cursor: "pointer",
      borderRadius: "20px",
      width: "40px",
      height: "40px"
    },
    animatedIconSmall: {
      cursor: "pointer",
      padding: "8px"
    }
  };
});
var IconButton = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$disableHoverBack = _ref.disableHoverBackground,
    disableHoverBackground = _ref$disableHoverBack === void 0 ? false : _ref$disableHoverBack,
    variant = _ref.variant,
    children = _ref.children,
    className = _ref.className,
    enlargeOnHover = _ref.enlargeOnHover,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "large" : _ref$size,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? "" : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? "" : _ref$height,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles();
  if (variant && variant in classes) {
    className = classNames(className, classes[variant]);
  }
  return /*#__PURE__*/_jsx(MuiIconButton, _objectSpread(_objectSpread({
    ref: ref,
    className: classNames(className, _defineProperty(_defineProperty({}, classes.transition, enlargeOnHover), classes.disableHoverBackground, disableHoverBackground)),
    size: size,
    style: width && height ? {
      width: width,
      height: height
    } : {}
  }, props), {}, {
    children: children
  }));
});
export default IconButton;